jQuery(document).ready(function () {
  let iconSearch = jQuery(".icon-search");
  let bodyEl = jQuery("body");
  let searchContainer = jQuery(".search-container");
  let searchClose = jQuery(".search-container .close");

  iconSearch.on("click", function (event) {
    event.preventDefault();
    searchContainer.addClass("active");
    jQuery(".search-field").focus();
    bodyEl.addClass("scroll-deactivated");
  });

  searchClose.on("click", function (event) {
    searchContainer.removeClass("active");
    bodyEl.removeClass("scroll-deactivated");
  });
});
